<!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "large" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" ></p></ngx-spinner> -->
<app-main-nav></app-main-nav>
  <div fxLayout="row" fxLayoutAlign="center center" class="p-4" style="padding-bottom: 10px !important;">
    <div fxFlex="25" class="p-2" fxLayout="column">
      <mat-card class="example-card dash-card">
        <mat-card-content>
          <mat-card-title-group>
            <span class="dash-span">
              <img src="http://futurepro.anudip.org/school/assets/school.png" style="width: 100%;"/>
            </span>
            <mat-card-title class="mat-card-title ml-2 mt-1">School</mat-card-title>
            <mat-card-subtitle class="mat-card-title ml-2 mt-1" style="font-size: 16px;font-weight: bold;">{{total_school}}</mat-card-subtitle>
          </mat-card-title-group>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxFlex="25" class="p-2" fxLayout="column">
      <mat-card class="example-card dash-card">
        <mat-card-title-group>
          <mat-card-title class="mat-card-title ml-2 mt-1">Classroom</mat-card-title>
          <mat-card-subtitle class="mat-card-title ml-2 mt-1" style="font-size: 16px;font-weight: bold;">{{total_classroom}}</mat-card-subtitle>
          <span class="dash-span">
            <img src="http://futurepro.anudip.org/school/assets/classroom.png" style="width: 100%;"/>
          </span>
        </mat-card-title-group>
        <mat-card-content>
          
        </mat-card-content>
      </mat-card>
    </div>
    <div fxFlex="25" class="p-2" fxLayout="column">
      <mat-card class="example-card dash-card">
        <mat-card-title-group>
          <mat-card-title class="mat-card-title ml-2 mt-1">Student</mat-card-title>
          <mat-card-subtitle class="mat-card-title ml-2 mt-1" style="font-size: 16px;font-weight: bold;">{{total_student}}</mat-card-subtitle>
          <span class="dash-span">
            <img src="http://futurepro.anudip.org/school/assets/student.png" style="width: 100%;"/>
          </span>
        </mat-card-title-group>
        <mat-card-content>
          
        </mat-card-content>
      </mat-card>
    </div>
    <div fxFlex="25" class="p-2" fxLayout="column">
      <mat-card class="example-card dash-card" *ngIf="dashboard.role_id == 27">
        <mat-card-title-group>
          <mat-card-title class="mat-card-title ml-2 mt-1">Faculty</mat-card-title>
          <mat-card-subtitle class="mat-card-title ml-2 m1-3" style="font-size: 16px;font-weight: bold;">{{total_faculty}}</mat-card-subtitle>
          <span class="dash-span">
            <img src="http://futurepro.anudip.org/school/assets/faculty.png" style="width: 100%;"/>
          </span>
        </mat-card-title-group>
        <mat-card-content>
          
        </mat-card-content>
      </mat-card>
      <mat-card class="example-card dash-card" *ngIf="dashboard.role_id == 28">
        <mat-card-title-group>
          <mat-card-title class="mat-card-title ml-2 mt-1">Dean</mat-card-title>
          <mat-card-subtitle class="mat-card-title ml-2 mt-1" style="font-size: 16px;font-weight: bold;">{{reporting_member.first_name}} {{reporting_member.middle_name}} {{reporting_member.last_name}}</mat-card-subtitle>
          <span class="dash-span">
            <img src="http://futurepro.anudip.org/school/assets/dean.png" style="width: 100%;"/>
          </span>
        </mat-card-title-group>
        <mat-card-content>
          
        </mat-card-content>
      </mat-card>
    </div>

  </div>

  <div fxLayout="row" fxLayoutAlign="center center" class="p-4" style="padding-top: 10px !important;">
    <!-- <div *ngIf="loading" style="position: absolute;width: 98%;height: auto;background: #0000009e;z-index: 10;top: 85px;bottom: 24px;">
      <span>Loading....</span>
    </div> -->
    <div fxFlex="50" class="p-2" fxLayout="column">
      <mat-card class="example-card" style="background: linear-gradient(45deg, #7fc08e70 0%, #49bed166 65%);min-height: 220px;border: 1px solid #1da4b5;">
        <mat-card-header>
          <mat-card-title>Classroom Progress</mat-card-title>
          <mat-icon style="position: absolute;right: 15px;color: #006580;cursor: pointer;" #tooltip="matTooltip" matTooltip="Button that displays a tooltip that hides when scrolled out of the container Button that displays a tooltip that hides when scrolled out of the container" matTooltipPosition="left" matTooltipHideDelay="100000">info</mat-icon>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content style="height: 400px;overflow-y: auto;max-height: 400px;">
          <mat-list>
            <mat-list-item *ngFor="let batch_progress of progress">
              <div mat-line class="mb-1">{{batch_progress.name}} <span style="float: right;font-weight: bold;">{{batch_progress.progress}}%</span></div>
              <div mat-line>
                <mat-progress-bar mode="determinate" value="{{batch_progress.progress}}" class="progressbar"></mat-progress-bar>
              </div>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxFlex="50" class="p-2" fxLayout="column">
      <mat-card class="example-card" style="background: linear-gradient(45deg, #49bed166  0%, #7fc08e70 65%);min-height: 220px;border: 1px solid #1da4b5;">
        <mat-card-header>
          <mat-card-title>Current School</mat-card-title>
          <mat-icon style="position: absolute;right: 15px;color: #006580;cursor: pointer;" #tooltip="matTooltip" matTooltip="Button that displays a tooltip that hides when scrolled out of the container Button that displays a tooltip that hides when scrolled out of the container" matTooltipPosition="left" matTooltipHideDelay="100000">info</mat-icon>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content style="height: 400px;overflow-y: auto;max-height: 400px;">
          <mat-list>
            <mat-list-item *ngFor="let sch of school">
              <div mat-line class="mb-1" style="color: #006580;">
                <span style="font-weight: bold;color: #006580;">{{sch.short_code}}</span>
                - {{sch.name}}
              </div>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  
  